var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('canvas',{ref:"canvas",on:{"mousedown":_vm.startDrawing,"mousemove":_vm.drawLine,"mouseup":_vm.stopDrawing}}),_vm._v(" "),_c('button',{on:{"click":_vm.resetCanvas}},[_vm._v("Reset Canvas")]),_vm._v(" "),_c('br'),_vm._v("\n  "+_vm._s(_vm.lines)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }